import { STORY_REPORT_COLUMNS, StoryReportReason } from "./story-report-column";
import DataTable from "../../../components/common/data-table/data-table";
import { StoryReportSchema } from "./story-report-schema";
import StoryReportForm from "./story-report-form";

interface StoryReportProps {
  userId?: string;
}
const StoryReport: React.FC<StoryReportProps> = ({ userId }) => {
  return (
    <div>
      <DataTable
        tableName="Story Reports"
        parentTableName="Overview"
        deleteTitle="Story Report"
        mainCol="title"
        getAllLink="/api/admin/user-stories" //TODO add "api" to base rout
        getAllParameters={{ userId: userId }}
        deleteRowLink="/api/admin/user-stories" //TODO add "api" to base rout
        getItemLink="api/admin/user-stories/report" //TODO add "api" to base rout
        updateItemLink="api/admin/user-stories/report" //TODO add "api" to base rout
        tableCols={STORY_REPORT_COLUMNS}
        formSchema={StoryReportSchema}
        FormContent={StoryReportForm}
        // formSchema={ParentSchema}
        hasSearch={false}
        hasEdit={true}
        hasDelete={false}
        tableDataMapper={(rows) => {
          return rows?.map((row: any, index: number) => {
            return {
              ...row,
              reason:
                StoryReportReason[
                  row.reason as keyof typeof StoryReportReason
                ] ?? row.reason,
              userType: row?.user?.userType,
              isDeleted: !!row?.userStory?.deletedAt,
              isParentReport: row?.isParentReport ? "Parent" : "Child",
            };
          });
        }}
        formDataMapper={(data: any) => {
          return {
            ...data,
            mediaType: data?.mediaType?.label,
            status: data?.status?.value,
            category: data?.userStory?.challenge_category?.title,
            reporterType: data?.isParentReport ? "Parent" : "Child",
            reason:
              StoryReportReason[
                data.reason as keyof typeof StoryReportReason
              ] ?? data.reason,
          };
        }}
        formSubmitMapper={(data: any) => {
          return {
            status: data?.status,
          };
        }}
      />
    </div>
  );
};

export default StoryReport;
